import {dotx, xlsx, pptx, jpg, pdf, txt, zip, defaultattachment, gif} from '../../../../../images';
import {AttachmentType} from '../../../../../components/FileUploader';

export function getImgByExt(ext: string) {
    if (ext === 'dotx' || ext === 'doc' || ext === 'docx') {
        return dotx;
    }
    if (ext === 'xlsx' || ext === 'xls' || ext === 'xlsm' || ext === 'xltm') {
        return xlsx;
    }
    if (ext === 'pptx' || ext === 'ppt') {
        return pptx;
    }
    if (ext === 'jpg' || ext === 'jpe' || ext === 'jpeg' || ext === 'png') {
        return jpg;
    }
    if (ext === 'pdf') {
        return pdf;
    }
    if (ext === 'txt') {
        return txt;
    }
    if (ext === 'zip') {
        return zip;
    }
    if (ext === 'gif') {
        return gif;
    }
    return defaultattachment;
}

export const createPriorityFileObj = async (file: File): Promise<AttachmentType> => {
    const byteArray = await getAsByteArray(file);
    const delim = '.';
    const nameSplit = file?.name?.split(delim);
    return {
        Data: byteArray,
        MimeType: file.type,
        Extension: nameSplit.length > 1 ? `${delim}${nameSplit[nameSplit.length - 1]}` : ''
    };
};

const getAsByteArray = async (file: File) => {
    return new Uint8Array(await readFile(file));
};

const readFile = async (file: File): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
        // Create file reader
        const reader = new FileReader();

        // Register event listeners
        reader.addEventListener('loadend', e => resolve(e.target.result as ArrayBuffer));
        reader.addEventListener('error', reject);

        // Read file
        reader.readAsArrayBuffer(file);
    });
};
